import { Component, effect, inject } from '@angular/core';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { RouterModule } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { ToolOverlayComponent } from '../../molecules/tool-overlay/tool-overlay.component';
import { ToastModule } from 'primeng/toast';
import { SplitterModule } from 'primeng/splitter';
import { AuthenticatedViewComponent } from './authenticated-view/authenticated-view.component';
import { ConfirmationService } from 'primeng/api';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { HelpDialogComponent } from '../../organisms/help-dialog/help-dialog.component';
import { RoleBasedHandler } from '../../../handlers/role-based-handler';
import { DataBackendSkeletonComponent } from '../../organisms/data-backend-skeleton/data-backend-skeleton.component';

@Component({
  selector: 'app-data-backend',
  standalone: true,
  imports: [
    RouterModule,
    SidebarModule,
    ToolOverlayComponent,
    ToastModule,
    SplitterModule,
    AuthenticatedViewComponent,
    HelpDialogComponent,
    DataBackendSkeletonComponent,
  ],
  providers: [ConfirmationService, ConfirmationDialogService],
  templateUrl: './data-backend.component.html',
  styleUrl: './data-backend.component.scss',
})
export class DataBackendComponent {
  readonly userStore = inject(ActiveUserStore);

  constructor(protected sidebarService: SidebarService) {
    this.userStore.setContext('dataBackend');
  }
}
